export const alignments = ['start', 'center', 'end'];
export const directions = ['top', 'bottom', 'right', 'left'];
